<template>
  <div>
    <!--表格栏-->
    <el-table :data="data" :highlight-current-row="highlightCurrentRow" @selection-change="selectionChange"
          @current-change="handleCurrentChange" v-loading="loading" element-loading-text="拼命加载中" :border="border" :stripe="stripe"
          :show-overflow-tooltip="showOverflowTooltip" :max-height="maxHeight" :size="size" :align="align"
          :header-cell-style="{background:'#f2f7fc',color:'#606266'}" style="width:98%;" >
          <!--选择框-->
          <el-table-column type="selection" width="40" v-if="batchDel"></el-table-column>
          <!--去掉了上下箭头的排序-->
          <el-table-column v-for="column in columns" header-align="center" align="center"
             :prop="column.prop" :label="column.label" :width="column.width" :min-width="column.minWidth"
             :fixed="column.fixed" :key="column.prop" :type="column.type" :formatter="column.formatter" v-if="!column.operate">
          </el-table-column>
          <!--操作栏-->
          <el-table-column label="操作" fixed="right" header-align="center" align="center" :width="showPrintBtn?'280':'auto'" v-if="showOperation">
            <template slot-scope="scope">
              <el-link :href="fillPath + '?salaryOrderId=' + scope.row.id" :underline="false" style="margin-right: 12px;" v-if="scope.row.filePath">
                <el-button icon="fa fa-download" label="下载" :perms="permsDown" :size="size">下载</el-button>
              </el-link>
              <!--<kt-button icon="fa fa-download" label="下载" :perms="permsDown" :size="size"  @click="handleDown(scope.$index, scope.row)" v-if="scope.row.filePath"/>-->
              <kt-button icon="fa fa-download" label="下载" :perms="permsDown" :size="size"  :disabled="true" style="background:#eee;" v-else/>
              <kt-button icon="fa fa-trash" label="删除" :perms="permsDelete" :size="size" type="danger" @click="handleDelete(scope.$index, scope.row)"/>
              <kt-button icon="el-icon-printer" label="打印" :size="size" type="success" @click="handlePrint(scope.row)" v-if="showPrintBtn"/>
            </template>
          </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding:10px;">
      <kt-button label="批量删除" :perms="permsDelete" :size="size" type="danger" @click="handleBatchDelete()"
        :disabled="this.selections.length===0" style="float:left;" v-if="batchDel"/>
      <el-pagination layout="total, prev, pager, next, jumper" @current-change="refreshPageRequest"
        :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize" :total="pageRequest.total" style="float:right;" v-if="showBatchDelete">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import KtButton from "@/components/KtButton"
import { baseUrl } from '@/utils/global'
export default {
  components:{
    KtButton
  },
  name: 'KtTable',
  props: {
    columns: Array, // 表格列配置
    data: Array, // 表格分页数据
    permsEdit: String,  // 编辑权限标识
    permsDelete: String,  // 删除权限标识
    permsAccess: String,  // 配置权限标识
    permsDown:String, //下载权限标识
    size: { // 尺寸样式
      type: String,
      default: 'mini'
    },
    align: {  // 文本对齐方式
      type: String,
      default: 'left'
    },
    maxHeight: {  // 表格最大高度
      type: Number,
      default:360
    },
    showOperation: {  // 是否显示操作组件
      type: Boolean,
      default: false
    },
    batchDel: {  // 默认不支持批量删除
      type: Boolean,
      default: false
    },
    border: {  // 是否显示边框
      type: Boolean,
      default: true
    },
    stripe: {  // 是否显示斑马线
      type: Boolean,
      default: false
    },
    highlightCurrentRow: {  // // 是否高亮当前行
      type: Boolean,
      default: true
    },
    showOverflowTooltip: {  // 是否单行显示
      type: Boolean,
      default: true
    },
    showBatchDelete: {  // 是否显示分页
      type: Boolean,
      default: true
    },
    handleMore: {  // 是否显示操作组件中的点击显示更多（流程管理中的）
      type: Boolean,
      default: true
    },
    showPrintBtn: {  // 是否显示操作组件中的打印
      type: Boolean,
      default: false
    },
    isInitialize: {  // 是否自动加载findPage方法
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      // 分页信息
      pageRequest: {
        pageNum: 1,
        pageSize: 10
      },
      loading: false,  // 加载标识
      selections: [], // 列表选中列
      fillPath:baseUrl + '/salaryOrderUploadExcel/downLoadExcel',
    }
  },
  methods: {
    // 分页查询
    findPage: function () {
        this.loading = true
        let callback = res => {
          this.loading = false
        }
        this.$emit('findPage', {pageRequest:this.pageRequest, callback:callback})
    },
    // 选择切换
    selectionChange: function (selections) {
      this.selections = selections
      this.$emit('selectionChange', {selections:selections})
    },
    // 选择切换
    handleCurrentChange: function (val) {
      this.$emit('handleCurrentChange', {val:val})
    },
    // 换页刷新
    refreshPageRequest: function (pageNum) {
      this.pageRequest.pageNum = pageNum
      this.findPage()
    },
    // 打印
    handlePrint: function (row) {
        this.loading = true;
        let callback = res => {
            this.loading = false
        }
        this.$emit('handlePrint',{row,callback:callback})
    },
    // 删除
    handleDelete: function (index, row) {
        this.delete(row.id)
    },
    // 批量删除
    handleBatchDelete: function () {
        let ids = this.selections.map(item => item.id).toString()
        this.delete(ids)
    },
    // 删除操作
    delete: function (ids) {
        if(ids == ''){
            this.$message({message: '请选择要删除的列表!', type: 'error'})
        }else{
            this.$confirm('确认要删除当前薪资数据吗？', '提示', {
                type: 'warning'
            }).then(() => {
                let params = []
                let idArray = (ids+'').split(',')
                for(var i=0; i<idArray.length; i++) {
                    params.push({'id':idArray[i]})
                }
                this.loading = true
                let callback = res => {
                    if(res.status) {
                        this.$message({ message: '操作成功', type: 'success' })
                        this.findPage()
                    } else {
                        this.$message({message: '操作失败, ' + res.msg, type: 'error'})
                    }
                  this.loading = false
                }
                this.$emit('handleDelete', {params:params, callback:callback})
            }).catch(() => {})
        }
    }
  },
  mounted() {
    if(this.isInitialize) this.refreshPageRequest(1)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/KtTable.vue